import { EyeOutlined } from '@ant-design/icons'
import { Campaign as CampaignModel } from '@models/Campaign'
import {
  getCampaigns,
  selectCampaigns,
  setCampaignQuery,
} from '@store/CampaignReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { useAppDispatch, useAppSelector } from '@utils/hooks'
import { extractSortDataFromSorterResult } from '@utils/table/sorter'
import { Button, Flex, Space } from 'antd'
import { ColumnsType, TableProps } from 'antd/es/table'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const CampaignsPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const items = useAppSelector(selectCampaigns())
  const { query, isLoading } = useAppSelector((state) => state.campaign)
  const { isOpen } = useSBRM()

  const columns: ColumnsType<CampaignModel> = [
    {
      key: 'name',
      title: 'Nom',
      width: 300,
      render: (record: CampaignModel) => record.name,
    },
    {
      key: 'actions',
      align: 'right',
      render: (record: CampaignModel) => (
        <Space>
          <Button
            onClick={() => {
              navigate(record.id.toString())
            }}
            icon={<EyeOutlined />}
          />
          <SBRM.Actions
            actions={[SBRMAction.Delete]}
            entity={Entity.campaign}
            entityId={record.id}
          />
        </Space>
      ),
    },
  ]

  const handleTableChange: TableProps<CampaignModel>['onChange'] = (
    pagination,
    filters,
    sorter
  ) => {
    const newQuery: TableParams = {
      pagination,
      filters,
      ...extractSortDataFromSorterResult(sorter),
    }
    dispatch(setCampaignQuery(newQuery))
    dispatch(getCampaigns(newQuery))
  }

  useEffect(() => {
    dispatch(getCampaigns(query))
  }, [dispatch, isOpen])

  return (
    <Flex vertical className="container-row">
      <PageTitle
        level={5}
        title="Campagnes"
        toolbar={
          <SBRM.Actions
            entity={Entity.campaign}
            actions={[SBRMAction.Create]}
          />
        }
      />

      <SBTable
        scroll={{ x: 600 }}
        columns={columns}
        dataSource={items}
        pagination={query.pagination}
        loading={isLoading}
        onChange={handleTableChange}
      />
    </Flex>
  )
}

export default CampaignsPage
